import { useMutation } from 'react-query'
import forgotPasswordService, {
  ParamsType,
  ResponseType,
} from 'services/authentication/forgot-password-service'
import { MutateHookType } from 'types/mutate-hook-type'

type HookType = MutateHookType<ParamsType, ResponseType>

export const useForgotPassword: HookType = (options) => {
  const mutation = useMutation(forgotPasswordService, options)
  const { data, error, isLoading, mutate: fetch } = mutation
  return { data, error, isLoading, fetch }
}
